import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconHeartFilledStyle0 = cosmosIconCss;

const CosmosIconHeartFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHeartFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a0456d443a13287b00ac27c3d71f32e41258dd61', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '053475f6bc936e074e654d5a2e90c768fec25f05', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7c2925959ad723d3a92940e5667bc738fdca1e88', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.66 18.36-6.4-6.63A4.57 4.57 0 0 1 3 8.58 4.011 4.011 0 0 1 6.97 4.5 3.925 3.925 0 0 1 9.8 5.72L11 6.94l1.2-1.22a3.925 3.925 0 0 1 2.83-1.22A4.011 4.011 0 0 1 19 8.58a4.506 4.506 0 0 1-1.26 3.15l-6.4 6.63a.444.444 0 0 1-.34.14.444.444 0 0 1-.34-.14Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconHeartFilledStyle0; }
}, [1, "cosmos-icon-heart-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-heart-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-heart-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHeartFilled$1);
            }
            break;
    } });
}

const CosmosIconHeartFilled = CosmosIconHeartFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHeartFilled, defineCustomElement };
